module.exports = __webpack_public_path__ + "img/rope_eye-jaw_8.e812874c.jpg";